import React from 'react'
import PropTypes from 'prop-types'

const CheckoutWithGift = ({
    accessToken,
    submitActionType,
    submitPayload,
    WizardRedux,
}) => (
    <WizardRedux.Wrapper
        submitActionType={submitActionType}
        submitPayload={submitPayload}
        id="GiftWizard"
    >
        {!accessToken && (
            <WizardRedux.StepRoute
                url="/login"
                as="/login"
            />
        )}
        <WizardRedux.StepRoute
            method={!accessToken ? 'replace' : 'push'}
            url="/gift-form"
            as="/gift-form"
        />
        <WizardRedux.StepRoute
            method="replace"
            url="/finalize-payment"
            as="/finalize-payment"
        />
        {/* <WizardRedux.StepRoute
                url="/select-newsletters"
                as="/select-newsletters"
            /> */}
    </WizardRedux.Wrapper>
)

CheckoutWithGift.propTypes = {
    accessToken: PropTypes.string.isRequired,
    submitActionType: PropTypes.string.isRequired,
    submitPayload: PropTypes.object.isRequired,
    WizardRedux: PropTypes.shape({
        Wrapper: PropTypes.element,
        StepRoute: PropTypes.element,
    }).isRequired,
}

export default CheckoutWithGift
